import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUser: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconUser"><Path d="M16.168 12.1699C18.4663 13.5755 20 16.1087 20 19V21H4V19C4 16.109 5.53311 13.5755 7.83105 12.1699C8.95551 13.1237 10.4101 13.7002 12 13.7002C13.5896 13.7002 15.0436 13.1234 16.168 12.1699Z" fill="currentColor"/><Path d="M12 2.5C14.6234 2.5 16.75 4.62665 16.75 7.25C16.75 9.87335 14.6234 12 12 12C9.37665 12 7.25 9.87335 7.25 7.25C7.25 4.62665 9.37665 2.5 12 2.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUser;
